// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.icon[data-v-ce57a850] {
    margin-top: auto;
    margin-bottom: auto;
    margin-left: 0.75rem;
    padding: 0;
    opacity: 1
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/toasts/ToastClose.vue"],"names":[],"mappings":";AAsBA;IAAA,gBAAA;IAAA,mBAAA;IAAA,oBAAA;IAAA,UAAA;IAAA;AAAA","sourcesContent":["<template>\n  <Icon name=\"close\" :color=\"NEUTRAL_SUPERDARK\" :size=\"13\" />\n</template>\n\n<script>\nimport { getColor } from '@/lego/utils/tailwind/config';\nimport Icon from '@/lego/components/icons/Icon.vue';\n\nconst NEUTRAL_SUPERDARK = getColor('neutral.superdark');\n\nexport default {\n  components: { Icon },\n  setup() {\n    return {\n      NEUTRAL_SUPERDARK,\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.icon {\n  @apply opacity-100 p-0 ml-micro my-auto;\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
